import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import { IPagination } from './interface';

function PaginationComponent(props: IPagination) {
  const pageNumber: any = [];

  for (let i = 1; i <= Math.ceil(props.totalData / props.dataPerPage); i += 1) {
    pageNumber.push(i);
  }

  function currentPageMoreThanOne() {
    if (props.currentPage > 1 && props.currentPage < 3) {
      return (
        <>
          <Pagination.Item onClick={() => props.paginate(1)}>1</Pagination.Item>
          <Pagination.Prev
            onClick={() => props.paginate(props.currentPage - 1)}
          />
          <Pagination.Item
            onClick={() => props.paginate(props.currentPage - 1)}>
            {props.currentPage - 1}
          </Pagination.Item>
        </>
      );
    }
    return <> </>;
  }

  function currentPageMoreThanTwo() {
    if (props.currentPage > 2) {
      return (
        <>
          <Pagination.Item onClick={() => props.paginate(1)}>1</Pagination.Item>
          <Pagination.Prev
            onClick={() => props.paginate(props.currentPage - 1)}
          />
          <Pagination.Item
            onClick={() => props.paginate(props.currentPage - 2)}>
            {props.currentPage - 2}
          </Pagination.Item>
          <Pagination.Item
            onClick={() => props.paginate(props.currentPage - 1)}>
            {props.currentPage - 1}
          </Pagination.Item>
        </>
      );
    }
    return <> </>;
  }

  function currentPageLessThanLast() {
    if (
      props.currentPage > pageNumber.length - 3 &&
      props.currentPage < pageNumber.length
    ) {
      return (
        <>
          <Pagination.Item
            onClick={() => props.paginate(props.currentPage + 1)}>
            {props.currentPage + 1}
          </Pagination.Item>
          <Pagination.Next
            onClick={() => props.paginate(props.currentPage + 1)}
          />
          <Pagination.Item onClick={() => props.paginate(pageNumber.length)}>
            {pageNumber.length}
          </Pagination.Item>
        </>
      );
    }
    return <> </>;
  }

  function currentPageLessThanPenultimate() {
    if (props.currentPage < pageNumber.length - 2) {
      return (
        <>
          <Pagination.Item
            onClick={() => props.paginate(props.currentPage + 1)}>
            {props.currentPage + 1}
          </Pagination.Item>
          <Pagination.Item
            onClick={() => props.paginate(props.currentPage + 2)}>
            {props.currentPage + 2}
          </Pagination.Item>

          <Pagination.Next
            onClick={() => props.paginate(props.currentPage + 1)}
          />
          <Pagination.Item onClick={() => props.paginate(pageNumber.length)}>
            {pageNumber.length}
          </Pagination.Item>
        </>
      );
    }
    return <></>;
  }

  return (
    <Pagination>
      {currentPageMoreThanOne()}
      {currentPageMoreThanTwo()}
      <Pagination.Item
        active
        key={4}
        onClick={() => props.paginate(props.currentPage)}>
        {props.currentPage}
      </Pagination.Item>
      {currentPageLessThanPenultimate()}
      {currentPageLessThanLast()}
    </Pagination>
  );
}

export default PaginationComponent;
